import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import * as i18nActions from "@rentiohq/shared-frontend/dist/redux/i18n/i18n.actions";
import { connect } from "react-redux";
import { IRootState } from "../../redux/reducers";
import ProfileMenu from "./ProfileMenu";
import { IDispatchProps, IProps, IStateProps } from "./ProfileMenu.types";

const mapStateToProps = (state: IRootState): IStateProps => ({
  hasAccessToken: authSelectors.hasAccessToken(state),
  user: authSelectors.getUser(state),
});

const mapDispatchToProps: IDispatchProps = {
  signOut: () => ({ type: "LOG_OUT" }),
  setLocale: i18nActions.setLocale,
};

// eslint-disable-next-line import/no-default-export
export default connect<IStateProps, IDispatchProps, IProps, IRootState>(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileMenu);
